import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { connect } from 'react-redux';

const getTypeValue = (type) => {
    switch (type) {
        case "text":
            return "title"
        case "number":
            return "numbers"
        case "object":
            return "data_object"
        case "array":
            return "data_array"
        case "boolean":
            return "rule"
        case "any":
            return "question_mark";
        default:
            return ""
    }
}

function ReturnTypeValue(props) {
    const { translate, Intl, type } = props;
    return (
        <>
        {type &&
        <div className='return-data-type'>
            <span className="material-symbols-outlined">{getTypeValue(type)}</span>
            <span>{translate(`datatype__${type}`)}</span>
        </div>}
        {!type &&
        <div className='return-data-type'>
            <span>{translate('returndatatype__noreturndata')}</span>
        </div>}
        </>
    );
}
function mapStateToProps(state) {
    return {
        Intl: state.Intl,
    }
}
export default connect(mapStateToProps)(withTranslate(ReturnTypeValue));